export const SET_REPORT = "SET_REPORT";
export const SET_REPORTS = "SET_REPORTS";

export const SET_BALANCE_SHEET_DATA = "SET_BALANCE_SHEET_DATA";
export const SET_PROFIT_AND_LOSS = "SET_PROFIT_AND_LOSS";
export const SET_JOURNALS = "SET_JOURNALS";
export const SET_CAPITALS = "SET_CAPITALS";
export const SET_TRIAL_BALANCE = "SET_TRIAL_BALANCE";
export const SET_REVIEW_ACCOUNTS = "SET_REVIEW_ACCOUNTS";
export const SET_REPORT_TRANSACTIONS = "SET_REPORT_TRANSACTIONS";
export const SET_CREDITORS_AND_DEBTORS = "SET_CREDITORS_AND_DEBTORS";
export const SET_BANK_TRANSACTIONS = "SET_BANK_TRANSACTIONS";
export const SET_BANK = "SET_BANK";
export const SET_TAX_REPORT = "SET_TAX_REPORT";
export const SET_SALE_BY_PRODUCTS = "SET_SALE_BY_PRODUCTS";
export const SET_BUY_BY_PRODUCTS = "SET_BUY_BY_PRODUCTS";
export const SET_SALES_BY_FACTOR = "SET_SALES_BY_FACTOR";
export const SET_BUYS_BY_FACTOR = "SET_BUYS_BY_FACTOR";
export const SET_FACTOR_SUMMARY = "SET_FACTOR_SUMMARY";
export const SET_FACTOR_PROFIT = "SET_FACTOR_PROFIT";
export const SET_USER_LOGS = "SET_USER_LOGS";
export const SET_ACCOUNT_CARD = "SET_ACCOUNT_CARD";
export const SET_PRODUCT_CARD = "SET_PRODUCT_CARD";
export const SET_USER_CARD = "SET_USER_CARD";
